import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import Button from '@panneau/element-button';

var styles = {"container":"panneau-element-form-group-container","help":"panneau-element-form-group-help","errors":"panneau-element-form-group-errors","hasErrors":"panneau-element-form-group-hasErrors","label":"panneau-element-form-group-label"};

var propTypes = {
  name: PropTypes.string,
  label: PropTypes$1.label,
  errors: PropTypes$1.formErrors,
  helpText: PropTypes.node,
  children: PropTypes.node,
  horizontal: PropTypes.bool,
  floating: PropTypes.bool,
  inline: PropTypes.bool,
  isList: PropTypes.bool,
  isListItem: PropTypes.bool,
  isCard: PropTypes.bool,
  isHeading: PropTypes.bool,
  isCollapsible: PropTypes.bool,
  initialCollapsed: PropTypes.bool,
  withoutLabel: PropTypes.bool,
  withoutErrors: PropTypes.bool,
  labelAfter: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string
};
var defaultProps = {
  name: null,
  label: null,
  errors: null,
  helpText: null,
  children: null,
  horizontal: false,
  floating: false,
  inline: false,
  isList: false,
  isListItem: false,
  isCard: false,
  isCollapsible: false,
  initialCollapsed: true,
  isHeading: false,
  withoutLabel: false,
  withoutErrors: false,
  labelAfter: false,
  className: null,
  labelClassName: null
};
var FormGroup = function FormGroup(_ref) {
  var name = _ref.name,
    label = _ref.label,
    helpText = _ref.helpText,
    children = _ref.children,
    errors = _ref.errors,
    horizontal = _ref.horizontal,
    floating = _ref.floating,
    inline = _ref.inline,
    isList = _ref.isList,
    isListItem = _ref.isListItem,
    isCard = _ref.isCard,
    isHeading = _ref.isHeading,
    isCollapsible = _ref.isCollapsible,
    initialCollapsed = _ref.initialCollapsed,
    withoutLabel = _ref.withoutLabel,
    withoutErrors = _ref.withoutErrors,
    labelAfter = _ref.labelAfter,
    className = _ref.className,
    labelClassName = _ref.labelClassName;
  var labelBefore = !labelAfter;
  var isColumn = horizontal || inline;
  var _useState = useState(initialCollapsed),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var toggleCollapsed = useCallback(function () {
    setCollapsed(!collapsed);
  }, [collapsed, setCollapsed]);
  var labelClassNames = classNames([styles.label, _defineProperty({
    'form-label': !inline && !isListItem,
    'col-form-label': (inline || horizontal) && !isListItem,
    'px-2': horizontal && !isListItem,
    // 'text-nowrap': horizontal, // ?
    // 'col-sm-3': horizontal, // ?
    'card-header': isCard,
    'w-100': isCard,
    'fw-bold': isHeading,
    'pt-2': isList,
    'pb-2': isList,
    'd-flex': isCollapsible,
    'align-items-center': isCollapsible,
    'justify-content-between': isCollapsible,
    'align-items-end': isListItem,
    'pe-1': isCollapsible,
    'rounded border-bottom border-light border-secondary': isCollapsible && collapsed,
    dropup: isCollapsible && !collapsed
  }, labelClassName, labelClassName !== null)]);
  var innerLabel = isCollapsible ? label || null : label || null;
  var outerLabel = isCollapsible ? /*#__PURE__*/React.createElement(Button, {
    htmlFor: name,
    className: labelClassNames,
    onClick: toggleCollapsed
  }, innerLabel, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    style: {
      width: 20
    },
    className: "me-1",
    icon: collapsed ? faCaretRight : faCaretDown
  })) : /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    className: labelClassNames
  }, innerLabel);
  var labelElement = !withoutLabel && label !== null ? outerLabel : null;
  var helpElement = helpText !== null ? /*#__PURE__*/React.createElement("small", {
    className: classNames([styles.help, 'form-text', 'text-muted', {
      'card-body': isCard
    }])
  }, helpText) : null;
  var errorsElement = !withoutErrors && errors !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.errors, 'invalid-feedback', 'd-block', {
      'card-body': isCard
    }])
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, errors.map(function (error) {
    return /*#__PURE__*/React.createElement("li", {
      key: "error-".concat(error)
    }, error);
  }))) : null;
  var innerChildren = /*#__PURE__*/React.createElement("div", {
    className: classNames([{
      'card-body': isCard,
      collapse: isCollapsible,
      show: isCollapsible && !collapsed
    }])
  }, children);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({
      'border-top pt-3 mt-3': isHeading,
      'list-group-item': isListItem
    }, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([{
      row: isColumn,
      card: isCard,
      'g-0': isColumn,
      'align-items-center': isColumn,
      'form-floating': floating
    }])
  }, labelBefore && labelElement !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames([{
      'col-auto': isColumn
    }])
  }, labelElement) : null, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'col-auto': !isList && (isColumn || !horizontal || labelElement === null),
      'ms-auto': isListItem && labelBefore,
      'me-auto': isListItem && labelAfter
    })
  }, innerChildren), labelAfter && labelElement !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'col-auto': isColumn
    })
  }, labelElement) : null, horizontal ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'col-auto': horizontal
    })
  }, helpElement), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'col-auto': horizontal
    })
  }, errorsElement)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'col-auto': horizontal
    })
  }, helpElement), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'col-auto': horizontal
    })
  }, errorsElement))));
};
FormGroup.defaultProps = defaultProps;
FormGroup.propTypes = propTypes;

export { FormGroup as default };
